import React from "react";
import Image from "components/image";
import Link from "components/link";
import clsx from "clsx/lite";

const CategoryMenu = ({ data }) => (
	<div className="flex w-full justify-center">
		<nav className="flex gap-4 justify-start overflow-x-auto md:gap-6 horizontal-padding py-3 no-scrollbar"
			aria-label="Category menu">
			{data.items?.map((item, index) => (
				<div key={item._key || index} className="category-menu-item group" aria-label={item.text}>
					<div className="overflow-hidden">
						<Image image={item.icon}
							className={
								clsx("w-[90px] md:w-[134px] xxl:w-[169px]",
									"group-hover:scale-110 transition ease-linear delay-250")}
						/>
					</div>
					<Link to={item?.icon?.url} >
						<p className={
							clsx("text-center text-sm md:text-base font-semibold group-hover:text-[#D6AD60]",
								"transition ease-linear delay-250 !leading-none")}>
							{item.text}
						</p>
					</Link>
				</div>
			))}
		</nav>
	</div>
);


export default CategoryMenu;